// extracted by mini-css-extract-plugin
module.exports = {"introduction":"introduction-module--introduction--1eUcY","aboutPhoto":"introduction-module--about-photo--2D9cg"};